import request from '@utils/request';
import { IAreaItem, IPrivacyPolicy } from '@src/types';

// 获取个人信息隐私保护政策法案
export async function getIndividualPrivacyStatus(): Promise<IPrivacyPolicy> {
  const res = await request.post('/api/official/user/individualPrivacy/getStatus');
  return res;
}

// 设置个保法状态
export async function setIndividualPrivacyStatus(): Promise<void> {
  const res = await request.post('/api/official/user/individualPrivacy/setStatus');
  return res;
}

// 判断是否可以修改手机号
export async function validaPhone(params) {
  const res = await request.post('/api/official/user/phone/change/check', params);
  return res;
}

// 获取城市区号
export async function getAllInterCode(params): Promise<IAreaItem[]> {
  const res = await request.post('/api/official/enum/getEnumByCategory', params);
  return res;
}

// 换绑手机号
export async function changPhoneBind(params) {
  const res = await request.post('/api/official/user/change/phone', params);
  return res;
}

// 微信登录绑定手机号
export async function bindPhone(params) {
  // 切换到微信扫码登录时清除cookie
  document.cookie = 'unionLoginType=weixin;path=/;domain=meituan.com;max-age=43200;';
  const res = await request.post(`/api/official/user/wechat/login/bind/phone`, params);
  return res;
}

// 解绑微信号
export async function unBindWechat(params) {
  const res = await request.post('/api/official/user/wechat/unbind', params);
  return res;
}

// 放弃疑似简历
export async function abandonSuspectedResume(params) {
  const res = await request.post(`/api/official/user/suspected/abandon`, params);
  return res;
}

// http://papi.sankuai.com/index/#/papi/project/195fa07e-3250-496a-904f-d392c5d0ec81?apiId=461fdcbf-5dfd-4e9a-8fde-7b47a0bb5e21&category=%E7%94%A8%E6%88%B7%E7%9B%B8%E5%85%B3
// 疑似简历验证
export async function validSuspectedResume(params) {
  const res = await request.post(`/api/official/user/suspected/valid`, params);
  return res;
}
